
import { defineComponent, computed, ref } from "vue";

interface DefaultValue {
  label: [string, number];
  value: any;
}
export default defineComponent({
  name: "CheckboxComponent",
  props: {
    typeCheckbox: {
      type: String,
      default: ""
    },

    valueSingleCheckbox: {
      type: String,
      default: ""
    },
    nameSingleCheckbox: {
      type: String,
      default: ""
    },
    disabledSingleCheckbox: {
      type: Boolean,
      default: false
    },
    nameGroupCheckbox: {
      type: String,
      default: ""
    },
    optionGroupCheckbox: Array,
    modelValue: {
      type: [Boolean, Array]
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "change"],

  setup(props, { emit, slots }) {
    const checkedCheckbox = computed({
      get: () => {
        return props.modelValue;
      },
      set: value => {
        if (typeof props.modelValue == "object") {
          const arr1 = JSON.parse(JSON.stringify(props.optionGroupCheckbox)),
            arr2 = JSON.parse(JSON.stringify(value));
          const filteredList = arr1.filter((item: DefaultValue) => {
            arr2.includes(item.value);
          });
          emit("change", filteredList);
        } else {
          emit("change", value);
        }

        return emit("update:modelValue", value);
      }
    });
    const checkTab = ref(false),
      closeTab = () => {
        checkTab.value = false;
      };
    const changeValueSingleSelect = (e: any) => {
      emit("change", e.target.checked);
    };

    return {
      checkedCheckbox,
      checkTab,
      closeTab,
      changeValueSingleSelect
    };
  },
  methods: {
    // eslint-disable-next-line
        isChecked: function(val: string) {
      if (typeof this.modelValue == "object")
        return this.modelValue.includes(val);
    }
  }
});
